import ApiService from '@/helpers/api.service';

const API = new ApiService();

export const state = {
    rolesList: [],
    rolesListPageInfo: {
        total: 0
    },
    roleAccess: [],
    roleSettings: [],
    errors: null
}

export const mutations = {
    UPDATE_ROLES_LIST(state, list){
        state.rolesList = list;
    },
    UPDATE_ROLES_LIST_PAGE_INFO(state, total){
        state.rolesListPageInfo.total = total;
    },
    SET_ROLE_ACCESS(state, access){
        state.roleAccess = access
    },
    SET_ROLE_SETTINGS(state, settings){
        state.roleSettings = settings
    },
    SET_PROD_ERRORS(state, errors){
        state.errors = errors;
    }
}

export const actions = {
    getRolesList(context, params){
        return new Promise((resolve, reject) => {
          API.post(`/roles/list`, params)
            .then(({ data }) => {
              context.commit('UPDATE_ROLES_LIST', data.message.rows);
              context.commit('UPDATE_ROLES_LIST_PAGE_INFO', data.message.pageInfo.total);
              resolve();
            })
            .catch(({ response }) => {
              context.commit('SET_PROD_ERRORS', response.data.errors);
              reject();
            });
        });
    },
    readRole(context, params){
        return new Promise((resolve, reject) => {
          API.post(`/roles/read`, params.body)
            .then(({ data }) => {
              context.commit('UPDATE_ROLES_LIST', data.message.rows);
              resolve();
            })
            .catch(({ response }) => {
              context.commit('SET_PROD_ERRORS', response.data.errors);
              reject();
            });
        });
    },
    manageRole(context, params){
        return new Promise((resolve, reject) => {
            API.post(`/roles/${params.action}`, params.body)
            .then(({ data }) => {
                if(data.status === "ok") {
                    resolve()
                } else {
                    reject(data.message)
                }
            })
            .catch(({ response }) => {
                context.commit('SET_PROD_ERRORS', response.data.errors);
                reject();
            });
        });
    },
    getAllRoles(context){
        return new Promise((resolve, reject) => {
            API.post(`/roles/getAllRoles`)
              .then(({ data }) => {
                context.commit('UPDATE_ROLES_LIST', data.message.rows);
                resolve();
              })
              .catch(({ response }) => {
                context.commit('SET_PROD_ERRORS', response.data.errors);
                reject();
              });
        });
    },
   getAccess(context, params){
        return new Promise((resolve, reject) => {
            API.post(`/roles/getUserAccess`, { email: params })
              .then(({ data }) => {
                context.commit('SET_ROLE_ACCESS', data.message.row);
                resolve(data.message.row);
              })
              .catch(({ response }) => {
                context.commit('SET_PROD_ERRORS', response.data.errors);
                reject();
              });
        });
    },
    getRoleSettings(context){
        return new Promise((resolve, reject) => {
            API.post(`/roles/getRoleSettings`)
              .then(({ data }) => {
                context.commit('SET_ROLE_SETTINGS', data.message.row);
                resolve(data.message.row);
              })
              .catch(({ response }) => {
                context.commit('SET_PROD_ERRORS', response.data.errors);
                reject();
              });
        });
    },
}